function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Additional driver",
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 231",
    style: {
      stroke: "rgba(247,247,247,.7)",
      strokeWidth: 4,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 156,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 154,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1986",
    d: "m436.791 54.712-1.077-2.441h1.72a4.134 4.134 0 0 0 0-8.269h-5.4l-4.32-9.765a5.524 5.524 0 0 0-5.045-3.288h-3.521l-1.368-3.819a4.708 4.708 0 0 0-4.413-3.13H402.75a4.7 4.7 0 0 0-4.419 3.13l-1.369 3.819h-3.443a5.533 5.533 0 0 0-5.045 3.288L384.156 44h-5.4a4.136 4.136 0 0 0-.118 8.269h2.972a16.75 16.75 0 0 1 15.7 11.1l.214.571A18.1 18.1 0 0 1 413.8 74.734l.939 2.126h9.424v4.9a3.53 3.53 0 0 0 3.52 3.544h4.378a3.53 3.53 0 0 0 3.521-3.544v-4.9h4.38a1.75 1.75 0 0 0 1.74-1.752V61.229a6.753 6.753 0 0 0-4.947-6.5zm-47.962-3.819 5.708-12.876H421.7l5.709 12.876zM430.2 71.86h-.469a6.221 6.221 0 0 1 0-12.442h.469a6.221 6.221 0 0 1 0 12.442z",
    transform: "translate(-212.697 65.084)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1987",
    d: "M332.042 81.892a3.53 3.53 0 0 0 3.519 3.544h4.38a3.53 3.53 0 0 0 3.52-3.544v-4.9h9.424l1.036-2.343a18.113 18.113 0 0 1 16.129-10.791l.216-.571a16.769 16.769 0 0 1 15.7-11.1h4.242a4.134 4.134 0 0 0-1.232-8.072h-5.4l-4.32-9.765a5.523 5.523 0 0 0-5.044-3.288H370.7l-1.368-3.819a4.709 4.709 0 0 0-4.419-3.13h-10.621a4.7 4.7 0 0 0-4.419 3.13l-1.369 3.819h-3.443a5.533 5.533 0 0 0-5.045 3.288l-4.32 9.765h-5.4a4.134 4.134 0 0 0 0 8.269h1.721l-1.075 2.441a6.731 6.731 0 0 0-4.947 6.5V75.2a1.749 1.749 0 0 0 1.74 1.752h4.282v4.9zm14.037-43.726h27.159l5.709 12.876h-38.575zm-8.406 21.2h.488a6.477 6.477 0 0 1 0 12.954h-.488a6.477 6.477 0 0 1 0-12.954z",
    transform: "translate(-243 65.152)",
    style: {
      fill: "#0f8560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 10",
    d: "M83.774 96.394A5.569 5.569 0 0 1 78.22 90.8v-7.718H27.473V90.8a5.574 5.574 0 0 1-5.559 5.595h-6.886a5.574 5.574 0 0 1-5.56-5.595v-7.718H2.743A2.759 2.759 0 0 1 0 80.325V58.494a10.63 10.63 0 0 1 7.821-10.269L9.5 44.439H6.769a6.517 6.517 0 0 1 0-13.034v.016h8.5l6.8-15.332a8.682 8.682 0 0 1 7.918-5.179H35.4l2.15-6A7.371 7.371 0 0 1 44.491 0H61.18a7.394 7.394 0 0 1 6.944 4.907l2.15 6h5.576a8.665 8.665 0 0 1 7.923 5.179l6.8 15.332h8.462a6.517 6.517 0 0 1 0 13.034v-.016h-2.688l1.679 3.787a10.63 10.63 0 0 1 7.814 10.267v21.835a2.753 2.753 0 0 1-2.736 2.757h-6.885V90.8a5.575 5.575 0 0 1-5.56 5.595zm-52.9-30.933a7.457 7.457 0 0 0 7.433 7.483h29.209a7.48 7.48 0 0 0 0-14.959H38.308a7.451 7.451 0 0 0-7.433 7.476zm49.943 0a6.266 6.266 0 0 0 6.241 6.28h.469a6.28 6.28 0 0 0 0-12.559h-.469a6.266 6.266 0 0 0-6.239 6.279zm-68.218 0a6.266 6.266 0 0 0 6.24 6.28h.475a6.28 6.28 0 0 0 0-12.559h-.474a6.266 6.266 0 0 0-6.24 6.279zm9.959-23.151h60.689l-8.978-20.24H31.541z",
    transform: "translate(101.749 126.523)",
    style: {
      fill: "#0f8560"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDriver);
export default __webpack_public_path__ + "static/media/additional-driver.8cea2cf6.svg";
export { ForwardRef as ReactComponent };